import { render, staticRenderFns } from "./MessageReactionModal.vue?vue&type=template&id=9baac9ca&scoped=true&"
import script from "./MessageReactionModal.vue?vue&type=script&lang=js&"
export * from "./MessageReactionModal.vue?vue&type=script&lang=js&"
import style0 from "./MessageReactionModal.vue?vue&type=style&index=0&id=9baac9ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9baac9ca",
  null
  
)

export default component.exports